import styles from "../styles/styles.module.css";

import { Input } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSurvey from "../../surveys/hooks/useSurvey";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";
import CustomUpload from "../../../components/CustomUpload/CustomUpload";
import { validateImage } from "../../../utils/validateImage";

const SurveysThanksUI = () => {
  const surveyInfo = useSelector((state) => state.surveyInfo);
  const [title, setTitle] = useState(undefined);
  const [description, setDescription] = useState(undefined);
  const refTime = useRef(null);
  const dispatch = useDispatch();
  const { saveFinishSurveyInfo, getSurveyInfo, saveImageSurvey } = useSurvey();

  useEffect(() => {
    if (surveyInfo) {
      setTitle(surveyInfo.title_final_page);
      setDescription(surveyInfo.final_message);
    }
  }, [surveyInfo]);

  const saveFinishSurveyInfoHandler = async (data) => {
    if (refTime.current) {
      clearTimeout(refTime.current);
    }
    refTime.current = setTimeout(async () => {
      dispatch(setLoadingSurvey(true));
      await saveFinishSurveyInfo(data);
      await getSurveyInfo(surveyInfo.id);
      dispatch(setLoadingSurvey(false));
    }, 500);
  };

  const handleFieldChange = (field, value) => {
    if (!surveyInfo) {
      return alert("Error: No existe una encuesta disponible.");
    }

    if (field === "title") setTitle(value);
    if (field === "description") setDescription(value);

    saveFinishSurveyInfoHandler({
      id_survey: surveyInfo.id,
      visit: field === "showLink" ? value : surveyInfo.visit,
      title_final_page: field === "title" ? value : title,
      final_message: field === "description" ? value : description,
      link_visit: field === "link" ? value : surveyInfo.link_visit,
    });
  };

  const uploadHomeImage = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();

    formData.append("id_survey", surveyInfo.id);
    formData.append("area", "final");
    formData.append("path_image_survey", file);

    const res = await saveImageSurvey(formData);

    if (res) {
      await getSurveyInfo(surveyInfo.id);
      onSuccess("ok");
      return;
    }

    onError?.("No se pudo guardar la imagen");
  };

  return (
    <div className={styles["home-container"]}>
      <div style={{ margin: "0 auto" }}>
        <CustomUpload
          customRequest={uploadHomeImage}
          beforeUpload={validateImage}
          defaultFileList={
            surveyInfo?.path_image_survey_final
              ? [
                  {
                    uid: surveyInfo?.path_image_survey_final,
                    name: surveyInfo?.path_image_survey_final,
                    status: "done",
                    url: surveyInfo?.path_image_survey_final,
                  },
                ]
              : []
          }
        >
          <div style={{ padding: 16 }}>
            {!surveyInfo?.path_image_survey_final
              ? "Subir Imagen"
              : "Actualizar Imagen"}
          </div>
        </CustomUpload>
      </div>

      <div className={`${styles["form-item"]} ${styles["form-item--title"]}`}>
        <span className={styles["form-item-label"]}>Título</span>
        <Input.TextArea
          value={title}
          autoSize
          bordered={false}
          onChange={(e) => handleFieldChange("title", e.target.value)}
        />
      </div>

      <div
        className={`${styles["form-item"]} ${styles["form-item--description"]}`}
      >
        <span className={styles["form-item-label"]}>Descripción</span>
        <Input.TextArea
          value={description}
          autoSize
          bordered={false}
          onChange={(e) => handleFieldChange("description", e.target.value)}
        />
      </div>

      {/* <div className={styles["form-item-row"]}>
        <div style={{ width: 250 }} className={`${styles["form-item--link"]}`}>
          <span className={styles["form-item-label"]}>Link</span>
          <Input
            placeholder="Pegar enlace aquí"
            value={link}
            autoSize
            onChange={(e) => handleFieldChange("link", e.target.value)}
          />
        </div>
        <Checkbox onChange={(e) => handleFieldChange("showLink", e.target.checked)} checked={showLink}>
          Mostrar
        </Checkbox>
      </div> */}
    </div>
  );
};

export default SurveysThanksUI;
